import {Toaster} from "react-hot-toast";

// react-hot-toast ships a plain white bubble by default — this brings it onto
// the app's dark glass surface (backdropForegroundRGB / backdropBorder) instead,
// matching every other overlay on this page (DarkModal, button-backdrop, ...).
const toastOptions = {
    style: {
        background: '#1f152d',
        color: '#F5F5F5',
        border: '0.5px solid #2E2E2E',
        borderRadius: 25,
        fontFamily: 'Onest, sans-serif',
        fontSize: 14,
    },
    success: {
        iconTheme: {primary: '#22c55e', secondary: '#F5F5F5'},
    },
    error: {
        iconTheme: {primary: '#ef4444', secondary: '#F5F5F5'},
    },
    loading: {
        iconTheme: {primary: '#a855f7', secondary: '#1f152d'},
    },
};

export default function Layout({children}) {
    return (
        <main className="font-body">
            <Toaster toastOptions={toastOptions}/>
            {children}
        </main>
    )
}
